import { useEffect, useState } from "react";
import { Loader2, MessageSquarePlus } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export function AddNoteDialog({ open, onOpenChange, onSubmit, title = "Add Note", subtitle }) {
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) setMessage("");
  }, [open]);

  const submit = async () => {
    if (!message.trim()) return;
    setSaving(true);
    try {
      await onSubmit(message.trim());
      onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="add-note-dialog">
        <DialogHeader>
          <div className="mb-1 flex h-10 w-10 items-center justify-center rounded-lg bg-brand-light text-primary">
            <MessageSquarePlus className="h-5 w-5" />
          </div>
          <DialogTitle>{title}</DialogTitle>
          {subtitle && <DialogDescription>{subtitle}</DialogDescription>}
        </DialogHeader>
        <Textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write a note for the timeline…"
          rows={4}
          data-testid="note-message-input"
          autoFocus
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="note-cancel">Cancel</Button>
          <Button onClick={submit} disabled={!message.trim() || saving} data-testid="note-save">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Add note"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
